import { tryParseJSONObject } from '@fox/atoms/utils/string';
import { SubscriptionAnswer } from '../../subscription-block/contracts';
import { QuestionValidator } from '../util/allow-next';

export const subscriptionRequirementsValidator: QuestionValidator = answer => {
	if (!answer) return false;
	const subscriptionAnswer = tryParseJSONObject<SubscriptionAnswer>(answer?.answer?.answerJson, {});
	if (!subscriptionAnswer.feeId) return false;

	return true;
};
